import map from 'lodash/map'
import type { ListFieldConfig } from '@ztechapps/common.hook'
import { ListFieldTypeEnum } from '@ztechapps/common.hook'
import { TaskStatus } from '@ztechapps/common.contract'

const Statuses = map(TaskStatus, (e) => e.value)

export const taskFieldsConfig: ListFieldConfig = {
  name: { name: 'name' },
  status: {
    name: 'status',
    displayName: 'Status',
    excludeOnSearch: true,
    type: ListFieldTypeEnum.select,
    fieldSettings: {
      listValues: Statuses,
    },
  },
  timeSpent: { name: 'timeSpent', excludeOnSearch: true, type: ListFieldTypeEnum.number },
  description: { name: 'description' },
  startDate: { name: 'startDate', displayName: 'Start Date', excludeOnSearch: true, type: ListFieldTypeEnum.date },
  endDate: { name: 'endDate', displayName: 'Due Date', excludeOnSearch: true, type: ListFieldTypeEnum.date },
  members: { name: 'members.profile.name', displayName: 'Members', excludeOnSort: true },
  remarks: { name: 'remarks' },
  tags: { name: 'tags', type: ListFieldTypeEnum.array },
}
